<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1GQBqN/tc-custom/9781607320678.jpg?1705201833738" alt="This image is the cover for the book Deep Freeze"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep Freeze
      </h1>
      <p class="bookDescription body article font2">
        <b>“A comprehensive and lively book about the people and events that transformed Antarctica into an international laboratory for science.”<b>—<b>Raimund E. Goerler, Chief Archivist/Byrd Polar Research Center of The Ohio State University</b><br/>  <br/> In <i>Deep Freeze</i>, Dian Olson Belanger tells the story of the pioneers who built viable communities, made vital scientific discoveries, and established Antarctica as a continent dedicated to peace and the pursuit of science, decades after the first explorers planted flags in the ice.<br/>  <br/> In the tense 1950s, even as the world was locked in the Cold War, U.S. scientists, maintained by the Navy’s Operation Deep Freeze, came together in Antarctica with counterparts from eleven other countries to participate in the International Geophysical Year (IGY). On July 1, 1957, they began systematic, simultaneous scientific observations of the south-polar ice and atmosphere. Their collaborative success over eighteen months inspired the Antarctic Treaty of 1959, which formalized their peaceful pursuit of scientific knowledge. Still building on the achievements of the individuals and distrustful nations thrown together by the IGY from mutually wary military, scientific, and political cultures, science prospers today and peace endures.<br/>  <br/> Belanger draws from interviews, diaries, memoirs, and official records to weave together the first thorough study of the dawn of Antarctica’s scientific age. <i>Deep Freeze</i> offers absorbing reading for those who have ventured onto Antarctic ice and those who dream of it, as well as historians, scientists, and policy makers.<br/>  <br/><b>“[A] highly informative and readable narrative account of perhaps the single most striking international scientific endeavor of the twentieth century.” —<i>The Polar Record</i></b><br/>  <br/><b>“<i>Deep Freeze,</i> based on countless interviews and painstaking research, is a timely and gripping account.” —John C. Behrendt, author of <i>Innocents on the Ice</i></b></b></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dian Olson Belanger
      </h2>
      
      <p class="authorDescription body article">Historian Dian Olson Belanger is the author of Enabling American Innovation (Purdue University Press, 1998) and Managing American Wildlife (University of Massachusetts Press, 1988).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University Press of Colorado
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69902875